var map = {
	"./symbol_0.png": "a131",
	"./symbol_1.png": "2ef0",
	"./symbol_10.png": "a38c",
	"./symbol_11.png": "5ae1",
	"./symbol_12.png": "313a",
	"./symbol_13_x10.png": "9444",
	"./symbol_13_x100.png": "9a06",
	"./symbol_13_x1000.png": "0133",
	"./symbol_13_x12.png": "855a",
	"./symbol_13_x15.png": "3467",
	"./symbol_13_x2.png": "4140",
	"./symbol_13_x20.png": "8197",
	"./symbol_13_x25.png": "5ce9",
	"./symbol_13_x3.png": "9a60",
	"./symbol_13_x4.png": "bbad",
	"./symbol_13_x5.png": "8eac",
	"./symbol_13_x50.png": "4c69",
	"./symbol_13_x6.png": "97d5",
	"./symbol_13_x8.png": "8e60b",
	"./symbol_2.png": "dc10",
	"./symbol_3.png": "5862",
	"./symbol_4.png": "616d",
	"./symbol_5.png": "81ea",
	"./symbol_6.png": "7d69",
	"./symbol_7.png": "de11",
	"./symbol_8.png": "f389",
	"./symbol_9.png": "79a8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1f29";